import { render, staticRenderFns } from "./AttentionManage.vue?vue&type=template&id=6499cfb7&scoped=true"
import script from "./AttentionManage.vue?vue&type=script&lang=js"
export * from "./AttentionManage.vue?vue&type=script&lang=js"
import style0 from "./AttentionManage.vue?vue&type=style&index=0&id=6499cfb7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6499cfb7",
  null
  
)

export default component.exports